import GuestInput from './GuestInput.jsx';

export default GuestInput;



// WEBPACK FOOTER //
// ./src/components/Header/MoveableDiv/SearchBar/GuestInput/index.js